(function () {

  //监听“联系我们”表单按钮
  const submitBtn = document.getElementsByClassName('contact-submit-btn')[0]
  const submitBtnSpan = submitBtn.getElementsByTagName('span')[0]
  submitBtn.addEventListener('click', function () {
    const name = document.getElementById('contact-name').value || ''
    const mobilePhone = document.getElementById('contact-phone').value || ''
    const merchantName = document.getElementById('contact-merchant_name').value || ''
    const remark = document.getElementById('contact-remark').value || ''

    const channelQuery = getQueryVariable('ADTAG')

    switch ('') {
      case name:
        showToast({ text: '请填写联系人' })
        return
      case mobilePhone:
        showToast({ text: '请填写联系电话' })
        return
      case merchantName:
        showToast({ text: '请填写商家名称' })
        return
    }

    if (!/^1[3456789]\d{9}$/.test(mobilePhone) && !/^0\d{2,3}-[1-9]\d{6,7}$/.test(mobilePhone)) {
      showToast({ text: '联系电话不合法' })
      return
    }

    submitBtnSpan.innerText = '请稍后...'
    submitBtn.setAttribute('disabled', 'disabled')
    window._providers.ddl.applySubmit({
      header: {},
      payload: {
        name: name,
        mobilePhone: mobilePhone,
        merchantName: merchantName,
        applicationSource: '店店联',
        channel: channelQuery ? `网页（${channelQuery}）` : '',
        remark: remark
      }
    }).then(res => {
      if (res.accepted && res.accepted[0]) {
        showToast({ text: '申请已发送' })
      } else {
        showToast({ text: '发生错误，申请发送失败' })
      }
      submitBtnSpan.innerText = '申请试用'
      submitBtn.removeAttribute('disabled')
    });
  })


})()